import { CONTACTS } from "@/content";
import { useLanguage } from "@/i18n";

const NAV_LINKS = [
    { href: "#hero", key: "home" },
    { href: "#consulenza", key: "consulenza" },
    { href: "#esperienza", key: "esperienza" },
    { href: "#casi", key: "progetti" },
];

export default function Footer() {
    const { t } = useLanguage();

    return (
        <footer data-testid="site-footer" className="bg-[#081627]">
            <div className="mx-auto flex max-w-7xl flex-col gap-8 px-6 py-14 lg:flex-row lg:items-end lg:justify-between lg:px-10">
                <div>
                    <p className="flex items-center gap-2.5 font-display text-lg font-bold tracking-tight text-white">
                        <span className="h-2.5 w-2.5 bg-sky-400" aria-hidden="true" />
                        CAPRI GIANLUCA
                    </p>
                    <p className="mt-3 font-mono text-[11px] uppercase tracking-[0.25em] text-[#5B8DEF]">
                        {t.footer.tagline}
                    </p>
                    <p className="mt-3 font-mono text-[11px] text-[#7A8899]">{CONTACTS.email}</p>
                </div>
                <nav className="flex flex-wrap gap-x-6 gap-y-2 font-mono text-[11px] uppercase tracking-widest text-[#9AA5B1]">
                    {NAV_LINKS.map((l) => (
                        <a
                            key={l.key}
                            href={l.href}
                            data-testid={`footer-link-${l.key}`}
                            className="transition-colors hover:text-[#5B8DEF]"
                        >
                            {t.nav[l.key]}
                        </a>
                    ))}
                    <a
                        href="#contatti"
                        data-testid="footer-link-contatti"
                        className="transition-colors hover:text-[#5B8DEF]"
                    >
                        {t.footer.talk}
                    </a>
                    <a
                        href="/contatti"
                        data-testid="footer-page-contatti"
                        className="transition-colors hover:text-[#5B8DEF]"
                    >
                        {t.footer.contactPage}
                    </a>
                </nav>
                <div className="font-mono text-[11px] text-[#7A8899]">
                    <p>
                        {CONTACTS.address} — P. IVA {CONTACTS.piva}
                    </p>
                    <p className="mt-2">
                        {t.footer.rights} ·{" "}
                        <a
                            href="/privacy"
                            data-testid="footer-privacy-link"
                            className="underline-offset-2 transition-colors hover:text-[#5B8DEF] hover:underline"
                        >
                            {t.footer.privacy}
                        </a>
                    </p>
                </div>
            </div>
        </footer>
    );
}
